function getFocusableElements(container) {
  if(container){
    return Array.from(
      container.querySelectorAll(
        "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
      )
    );
  }
  
}

const onmouseleaveHandeler = (e) => {
  if(e.classList.contains('variant_image_active')) {
    e.classList.remove('variant_image_active');
  }
}

(()=>{
  // let flickityList = document.querySelectorAll('[data-flickity]');

  // for (let i = 0, t = flickityList.length; i < t; i++) {
  //     let flkty = Flickity.data(flickityList[i]);
  //     if (flkty) {
  //       let vimeo_iframe = flkty.selectedElement.querySelector('iframe');

  //       if(vimeo_iframe) {
  //         let player = new Vimeo.Player(vimeo_iframe);
  //         player.on('loaded', (e) => {
  //           player.getPaused().then(function(paused) {
  //             if(paused) {
  //               player.play();
  //             }
  //           });
  //         });
  //       } else {
  //         return false;
  //       }
  //     }
  // }
})();

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  if(window.innerWidth > 750){
    if(summary.closest('header-menu')){
      summary.closest('details').addEventListener('mouseenter', (event) => {
        const detailsElement = event.currentTarget;
          if (!detailsElement.hasAttribute('open') && !detailsElement.classList.contains("menu-drawer-container") && !detailsElement.classList.contains("menu-drawer__menu-item")) {
            detailsElement.setAttribute('open', 'true');
            event.currentTarget.querySelector("summary").setAttribute('aria-expanded', 'true');
          }
        
      });
      
      summary.closest('details').addEventListener('mouseleave', (event) => {
        const detailsElement = event.currentTarget;
          if (detailsElement.hasAttribute('open') && !detailsElement.classList.contains("menu-drawer-container") && !detailsElement.classList.contains("menu-drawer__menu-item")) {
            detailsElement.removeAttribute('open');
            event.currentTarget.querySelector("summary").setAttribute('aria-expanded', 'false');
          }
      });
    }
  }
  
  summary.addEventListener('click', (event) => {
    if (summary.classList.contains('matat_filters__summary')) {
        const detailsElement = summary.closest("details");
        if (detailsElement && !detailsElement.hasAttribute("open")) {
          document.querySelectorAll(".matat-filter-body details[open]").forEach((openDetail) => {
              openDetail.removeAttribute("open");
          });
        }
        const sliderWrapper = document.getElementById('matat-range-slider');
          if (sliderWrapper.rangeable) {
            sliderWrapper.rangeable.destroy?.(); // Optional chaining
            sliderWrapper.style.display = 'none';
            sliderWrapper.offsetHeight; // force reflow
            sliderWrapper.style.display = '';
            MatatFiltersForm.priceRangeSlider(); // re-init
          }
      }
      if(summary.closest('.product__accordion')){ 
        const detailsElement = summary.closest("details");
        if (detailsElement && !detailsElement.hasAttribute("open")) {
          document.querySelectorAll(".product__accordion details[open]").forEach((openDetail) => {
              openDetail.removeAttribute("open");
          });
        }
      }
      // if(document.querySelector(".header__search details").hasAttribute("open")){
      //   document.querySelector(".header__search details").removeAttribute("open")
      // }
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  if (!elements || elements.length === 0) return;
  var first = elements[0];
  var last = elements[elements.length - 1];
  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  if (elementToFocus) {
    elementToFocus.focus();
  }

  function safeFocusAndSelect(element) {
    if (
      element &&
      element.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(element.type)
    ) {
      element.focus();
      if (element.value) {
        element.setSelectionRange(0, element.value.length);
      }
    }
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  // document.querySelectorAll('.js-youtube').forEach((video) => {
  //   video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  // });
  // document.querySelectorAll('.js-vimeo').forEach((video) => {
  //   video.contentWindow.postMessage('{"method":"pause"}', '*');
  // });
  // document.querySelectorAll('video').forEach((video) => video.pause());
  // document.querySelectorAll('product-model').forEach((model) => {
  //   if (model.modelViewerUI) model.modelViewerUI.pause();
  // });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button:not(.localization-selector)').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header && document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  connectedCallback() {
    this.loadContent();
  }

  loadContent(focus = true) {
    // window.pauseAllMedia();
    // if (!this.getAttribute('loaded')) {
    //   const content = document.createElement('div');
    //   content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

    //   this.setAttribute('loaded', true);
    //   const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
    //   if (focus) deferredElement.focus();
    //   if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
    //     // force autoplay for safari
    //     deferredElement.play();
    //   }
    // }
  }
}

customElements.define('deferred-media', DeferredMedia);

document.addEventListener('keydown', function (e) {
  if (e.key === ' ') {
    const target = e.target.closest('[role="button"]');
    if (target && target.tagName !== 'BUTTON' && target.tagName !== 'SUMMARY') {
      e.preventDefault();
      target.click();
    }
  }
});

document.body.addEventListener('click', function (e) {
    let target = e.target;
    if(target.classList.contains('custom_variation_button')) {
      let parentItem = target.closest('.product-card-wrapper').querySelector('.product-card_inline-variation').querySelector('.product-form__input.listen_color_change');
      let actual_var_item = parentItem.querySelector('[value="'+target.value+'"]');
          actual_var_item.checked = true;
          parentItem.dispatchEvent(new CustomEvent('color_change',{'detail': target.value}));
          actual_var_item.dispatchEvent(new Event('custom_change'));
          // let variant_radios = target.closest('.product-card-wrapper').querySelector('variant-radios');
          // variant_radios.dispatchEvent(new Event('change'));
    }
    if(target.closest('variant-radios') && target.closest('.product-card-wrapper')) {
      if(target.tagName.toUpperCase() == 'INPUT') {
        target.closest('variant-radios').dispatchEvent(new Event('change'));
      }
    }
});
document.addEventListener("DOMContentLoaded", (event) => {
  if(document.querySelector('.flikity_grid_image')){
        var carousel = document.querySelectorAll('.flikity_grid_image');
        var flkty;
        carousel.forEach((slide) => {
            flkty = new Flickity(slide, {
             "imagesLoaded": true,
              "rightToLeft": true,
              "cellAlign": "right",
              "pageDots": false,
              "wrapAround": true,
              "draggable": false,
              "responsive": [
                {
                  "breakpoint": 750,
                  "settings": {
                    "freeScroll": true,
                    "wrapAround": false,
                    "contain": true,
                    "prevNextButtons": true,
                    "draggable": false,
                    "pageDots": true
                  }
                }
              ]
          });
        })  
      }
  // if(document.querySelector(".product__media-list.Product_main_slider")){
  //     var carousel_main = document.querySelectorAll('.product__media-list.Product_main_slider');
  //     carousel_main.forEach((slide) => {
  //         flkty = new Flickity(slide, {
  //         "imagesLoaded": true,
  //         "rightToLeft":true,
  //         "cellAlign":"right",
  //         "pageDots": true,
  //         "prevNextButtons": true,
  //         "wrapAround": true
  //       });
  //     })
  //   }
  });

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);

    if(this.classList.contains('variant-product-card') && !this.classList.contains('no_image_change')) {
      if(this.querySelector('.product-form__input.listen_color_change') && this.querySelector('.product-form__input.image_switcher_activated')){
        this.querySelector('.product-form__input.listen_color_change').addEventListener('color_change', (e) => {
          const variant_image = this.updateSingleMedia(e.detail);
          if(e.target.closest(".card__inner").querySelector(".card__media").classList.contains("enable_image_slider")){
            if(variant_image){
               var taeget_index = e.target.closest(".card__inner").querySelector(".card__media").querySelector(`img[src="${variant_image}&width=460"]`).closest('.pro-media').dataset.index;
               var flkty = Flickity.data(e.target.closest(".card__inner").querySelector(".card__media .flickity_grid"));
               if(flkty){
                flkty.select(taeget_index)  
               }
            }
          }else{
            if(variant_image){
              // this.closest('.product-card-wrapper').querySelector('img.variant_image_element').srcset = variant_image;
              // this.closest('.product-card-wrapper').querySelector('img.variant_image_element').src = variant_image;
              const img = this.closest('.product-card-wrapper').querySelector('img.variant_image_element');
              if (img && this.currentVariant?.featured_media) {
                img.src = this.currentVariant.featured_media.preview_image.src;
                img.srcset = this.currentVariant.featured_media.preview_image.src;
              }
            }
            this.closest('.product-card-wrapper').classList.add('variant_image_active');
          }


          // Updating Variant Button
          const variant_details = this.getVariantDetails(e.detail);
          const $variant_input = this.closest('.product_quick_add_wrap').querySelectorAll('fieldset:not(.listen_color_change) .variant-button input');
          var $this = this;
          $variant_input.forEach(function(input){
            var this_value = input.getAttribute('value');
            switch(input.getAttribute('data-option')) {
              case "1":
                var condition = variant_details.find((x)=>{
                    return x.available && x.option1 == this_value
                });
                $this.updateVariantButton(condition, input)
                break;
              case "2":
                var condition = variant_details.find((x)=>{
                    return x.available && x.option2 == this_value
                });
                $this.updateVariantButton(condition, input)
                break;
              case "3":
                var condition = variant_details.find((x)=>{
                    return x.available && x.option3 == this_value
                });
                $this.updateVariantButton(condition, input)
                break;
              default:
            }
          });
        });
      }
    }
    if(this.querySelector(".custom-select")){
      this.querySelectorAll(".custom-select .custom-selected").forEach((select_opt) => {
        select_opt.addEventListener("click", (e) => {
            e.target.nextElementSibling.classList.toggle("active");
        })
      })
      this.querySelectorAll(".custom-select .custom-select-options div").forEach((opt) => {
        opt.addEventListener("click", (optval) => {
          this.querySelectorAll(".custom-select .custom-select-options div").forEach((optremove) => {
            optremove.classList.remove("selected_val");
          });
          let $optvalue = optval.target.innerHTML;
          optval.target.closest(".custom-select").querySelector(".custom-selected span").innerHTML = $optvalue;
          optval.target.closest(".custom-select-options").classList.remove("active");
          optval.target.classList.add("selected_val");
          // change real select option
          let $s = optval.target.closest(".product-form__input--dropdown").getElementsByTagName("select")[0];
          let $sl = $s.length;
          for (let i = 0; i < $sl; i++) {
            if ($s.options[i].innerHTML == $optvalue) {
              $s.options[i].selected = true;
              $s.dispatchEvent(new Event("change", { bubbles: true }));
              break;
            }
          }
        })    
      })
    }
  }
 
  // Dhruvik feature for on-relaod
  connectedCallback() {
    window.addEventListener('load', () => {
      setTimeout(() => {
        this.updateOptions();
        this.updateMasterId();
        this.slideToSelectedVariant();
      }, 200);
    });
  }

  updateVariantButton(condition, input){
    if(condition){
      input.classList.remove('disabled')
    }else{
      input.classList.add('disabled')
    }
  }

  onVariantChange(e) {
    const fieldset = e.target.querySelectorAll('fieldset');
    let checked_count = 0;
    fieldset.forEach((item)=>{
      if(item.querySelectorAll('input[type="radio"]:checked').length > 0) {
        checked_count++;
      }
    })
    if(checked_count < fieldset.length ) return;
    const product_card = this.closest('.product-card_inline-variation');
    if(product_card) {
        this.updateOptions();
        this.updateMasterId();
        this.toggleAddButton(true, '', false);
        this.updateVariantStatuses();

        if (!this.currentVariant) {
          this.toggleAddButton(true, '', true);
          this.setUnavailable();
        } else {
          this.updateVariantInput();
          this.renderProductInfo();
        }
        this.quickAddToCart();
    } else {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantStatuses();

      
      // if(e.target.closest('.product-form__input').classList.contains('variation-color-wrapper')) {
      //   // this.updateMedia(e.target.value);
      //   // this.slideToSelectedVariant(e.target.value);
      //   this.slideToSelectedVariant();
      // }
      this.slideToSelectedVariant();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
        this.updateShareUrl();
      }
    }
  }

  quickAddToCart() {
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
      let enabledCounter = 0;
      const variant_form = this.querySelector('product-form').querySelector('form');

    inputWrappers.forEach((option, index) => {
      const selectedOptionInput = option.querySelector(':checked');
      if(selectedOptionInput && !selectedOptionInput.classList.contains('disabled')) {
        enabledCounter++;
        if(enabledCounter == inputWrappers.length) {
          variant_form.dispatchEvent(new Event('submit'))
          this.closest('.product-card-wrapper').querySelector('.quick_add_loading').classList.remove('hidden')
          this.closest('.product-card-wrapper').classList.add('adding_cart')
        }
      }
      // const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      // const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
      // this.setInputAvailability(optionInputs, availableOptionInputsValue)

      // if(product_card && option.classList.contains('visually-hidden')) {
      //   product_card.closest('.product-card-wrapper').querySelector('.card-variation-color');
      //   const optionInputsVariant = [...product_card.closest('.product-card-wrapper').querySelector('.card-variation-color').querySelectorAll('input[type="radio"], option')]
      //   this.setInputAvailability(optionInputsVariant, availableOptionInputsValue)
      // }
    });
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia(color) {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    // const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    // mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    // const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    // if (!modalContent) return;
    // const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    // modalContent.prepend(newMediaModal);

    // this.getVariantData().find((variant) => {
    //   return !variant.options.map((option, index) => {
    //     return this.options[index] === option;
    //   }).includes(false);
    // });

    var variant_images = [...new Set(this.getVariantData().filter(variant => variant.title.includes(color)).map(function(obj) { return obj.featured_media.preview_image.src; }))];
    let main_images = [],
        thumb_images = [];

    for (let img_src of variant_images) {
      const main_classes = ['product__media-item', 'grid__item', 'slider__slide']
      let main_img = document.createElement("li");
      main_img.classList.add(...main_classes);
      main_img.innerHTML = `<a href="${img_src}" data-pswp-width="1000" data-pswp-height="1500">
                    <div class="product-media-container media-type-image media-fit-contain gradient" style="--ratio: 0.6666666666666666; --preview-ratio: 0.6666666666666666;">
                    <div class="product__media media media--transparent has_zoom_element">
                          <img src="${img_src}&amp;width=1946" alt="">
                        </div>
                    </div>
                  </a>`;
      main_images.push(main_img);

      const thumb_classes = ['thumbnail-list__item', 'slider__slide']
      let thumb_img = document.createElement("li");
      thumb_img.classList.add(...thumb_classes);
      thumb_img.innerHTML = `<button class="thumbnail global-media-settings global-media-settings--no-shadow"><img src="${img_src}&amp;width=416" alt=""></button>`;
      thumb_images.push(thumb_img);
    }

    const main_product_gallery = Flickity.data(this.closest('.single_main_product_wrapper').querySelector('.product__media-list[data-flickity]'));
    const main_old_cells = main_product_gallery.cells.map(cell => cell.element);
    if(main_old_cells.length) {
      main_product_gallery.remove(main_old_cells);
    }
    main_product_gallery.insert( main_images, 0 );
    main_product_gallery.select(0);

    const thumb_gallery = Flickity.data(this.closest('.single_main_product_wrapper').querySelector('.thumbnail_slider_side[data-flickity]'));
    const thumb_old_cells = thumb_gallery.cells.map(cell => cell.element);
    if(thumb_old_cells.length) {
      thumb_gallery.remove(thumb_old_cells);
    }
    setTimeout(() =>{
      if(thumb_images.length>4) {
        thumb_gallery.insert( thumb_images, 0 );
      } else {
        let flktyOptions = JSON.parse(thumb_gallery.element.dataset.flickity);
        delete flktyOptions.wrapAround;
        flktyOptions.contain = true;
        thumb_gallery.insert( thumb_images, 0 );

        setTimeout(() =>{
          thumb_gallery.destroy();
          let new_flickity = new Flickity(thumb_gallery.element, flktyOptions);
          new_flickity.reposition();
        },50);
      }
    },20);
  }

  // slideToSelectedVariant(color){
  //   console.log("working")
  //   if (!this.currentVariant) return;
  //   if (!this.currentVariant.featured_media) return;
  //   var variant_images = [...new Set(this.getVariantData().filter(variant => variant.title.includes(color)).map(function(obj) { return obj.featured_media.preview_image.src; }))];
  //   var target_image = variant_images[0];
  //   var taeget_index = document.querySelector(`.slider__slide a[href="${target_image}"]`).closest('.product__media-item').dataset.index;
  //   var flkty = Flickity.data(document.querySelector('.product-slider-gallery.Product_main_slider'));
  //   if(flkty){
  //     flkty.select(taeget_index)  
  //   }
  //   return;
  // }
  slideToSelectedVariant() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;

    const targetSrc = this.currentVariant.featured_media.preview_image.src.split('?')[0];

    const slideImg = document.querySelector(
      `.product-slider-gallery img[src*="${targetSrc}"]`
    );

    if (!slideImg) return;

    const slideItem = slideImg.closest('.product__media-item, .slider__slide');
    if (!slideItem) return;

    const targetIndex = Number(slideItem.dataset.index);
    const flkty = Flickity.data(document.querySelector('.product-slider-gallery'));

    if (flkty && !isNaN(targetIndex)) {
      flkty.select(targetIndex);
    }
  }

  updateSingleMedia(color) {
    const single_variant_data = this.getVariantData().find(variant => variant.title.includes(color));
    const variant_img_src = single_variant_data.featured_image? single_variant_data.featured_image.src : false;

    return variant_img_src;
  }

  getVariantDetails(color) {
    return this.getVariantData().filter(data=>data.title.includes(color));
  }

  updateURL() {
    const product_card = this.closest('.product-card_inline-variation');
    if (!this.currentVariant || this.dataset.updateUrl === 'false' || product_card) return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const product_card = this.closest('.product-card_inline-variation');
    if(product_card) {
        const productForm = this.querySelector(`#product-form-${this.dataset.section}`);
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        // input.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        if(document.querySelector(".product--giftcard")){
          document.querySelector(".product--giftcard").querySelectorAll(".price__container .price__regular .price-item--regular").forEach((e) =>{
            e.innerHTML = this.currentVariant.title;
          })
        }
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      // price change
      let $current_var_price = (this.currentVariant.price / 100).toFixed(2);
      let $current_var_price_money = `${$current_var_price} ₪`;
      document.querySelectorAll(".product__info-wrapper .change-price").forEach((e) => {
        e.innerHTML = $current_var_price_money;
      });

      // UPDATE STOCK NOTIFY BUTTON 
      const notifyBtn = document.querySelector(".matat-stock-notify-submit");
      if (notifyBtn && this.currentVariant) {
        notifyBtn.setAttribute("data-variant-id", this.currentVariant.id);
        notifyBtn.setAttribute("data-id", this.currentVariant.id);
        notifyBtn.setAttribute("data-variant-title", this.currentVariant.title);

        //notifyBtn.setAttribute("data-price", this.currentVariant.price / 100);
        // notifyBtn.setAttribute("data-price_min", this.currentVariant.price / 100);
        // notifyBtn.setAttribute("data-price_max", this.currentVariant.price / 100);
        notifyBtn.setAttribute("data-price", (this.currentVariant.price / 100).toFixed(2));
        notifyBtn.setAttribute("data-price_min", (this.currentVariant.price / 100).toFixed(2));
        notifyBtn.setAttribute("data-price_max", (this.currentVariant.price / 100).toFixed(2));
        
        // notifyBtn.setAttribute("data-price_varies", this.currentVariant.price_varies);

        if (this.currentVariant.featured_image) {
          notifyBtn.setAttribute("data-src", this.currentVariant.featured_image.src);
        }
      }
    }
  }

  updateVariantStatuses() {
    const product_card = this.closest('.product-card_inline-variation');
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      if(inputWrappers[index - 1].querySelector(':checked')){
        const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
        const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
        this.setInputAvailability(optionInputs, availableOptionInputsValue)
        if(product_card && option.classList.contains('visually-hidden')) {
          product_card.closest('.product-card-wrapper').querySelector('.card-variation-color');
          const optionInputsVariant = [...product_card.closest('.product-card-wrapper').querySelector('.card-variation-color').querySelectorAll('input[type="radio"], option')]
          this.setInputAvailability(optionInputsVariant, availableOptionInputsValue)
        }
      }
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;
    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
      console.log('Here');
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    const product_card = this.closest('.product-card_inline-variation');

    if (!section || product_card) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    const product_card = this.closest('.product-card_inline-variation');

    if(product_card) {
      fetch(`${this.dataset.url}?variant=${requestedVariantId}`)
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const raw_html = new DOMParser().parseFromString(responseText, 'text/html');
        const html = raw_html.querySelector('.single_main_product_wrapper');

        // const destination = document.getElementById(`price-${this.dataset.section}`);
        // const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        // const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        // const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        // const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        // const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        // if (source && destination) destination.innerHTML = source.innerHTML;
        // if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        // if (skuSource && skuDestination) {
        //   skuDestination.innerHTML = skuSource.innerHTML;
        //   skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        // }

        // const price = document.getElementById(`price-${this.dataset.section}`);

        // if (price) price.classList.remove('visibility-hidden');

        // if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.querySelector('.product-form__buttons .product-form__submit');
        const addButtonUpdatedText = addButtonUpdated ? addButtonUpdated.querySelector('span')?.textContent?.trim() : null;
        this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, addButtonUpdatedText || window.variantStrings.soldOut);

        publish(PUB_SUB_EVENTS.variantChange, {data: {
          sectionId,
          html,
          variant: this.currentVariant
        }});
      });
    } else {
      fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {

        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        const addButtonUpdatedText = addButtonUpdated ? addButtonUpdated.querySelector('span')?.textContent?.trim() : null;
        this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, addButtonUpdatedText || window.variantStrings.soldOut);

        //Sale Detected
        if(html.getElementById(`product-form-${this.dataset.section}`)){
          if(html.getElementById(`product-form-${this.dataset.section}`).closest('.product').querySelector(`.is-sale`)){
            const isSale = html.getElementById(`product-form-${this.dataset.section}`).closest('.product').querySelector(`.is-sale`);
            if(isSale){
              document.getElementById(`product-form-${this.dataset.section}`).closest('.product').querySelector('.sale').style.display = "inline-block";
            }else{
              document.getElementById(`product-form-${this.dataset.section}`).closest('.product').querySelector('.sale').style.display = "none";
            }
          }
        }
        publish(PUB_SUB_EVENTS.variantChange, {data: {
          sectionId,
          html,
          variant: this.currentVariant
        }});
      });
    }
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;
    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
      if(modifyClass && document.getElementById(`product-form-${this.dataset.section}`).closest('.product') && document.getElementById(`product-form-${this.dataset.section}`).closest('.product').querySelector('.out-of-stock')){
        document.getElementById(`product-form-${this.dataset.section}`).closest('.product').querySelector('.out-of-stock').style.display = "inline-block";
        if(document.querySelector(".backinstock_feature_enable")){
          addButton.closest(".product-form-main-container-outer").querySelector(".matat-backin-stock-alert").classList.add("active");
          addButton.classList.add("hidden");
          addButton.closest(".product-form-main-container-outer").classList.add("backinstock-active-main");
          addButton.closest("product-form").classList.add("backinstock-active");
        }
      }
    } else {
      addButton.removeAttribute('disabled');
      // Prefer the button text the server just rendered for this variant (falls back to the
      // generic "Add to cart" only if we don't have it) - templates like medical-product set
      // their own custom label here, which a hardcoded string would otherwise wipe out.
      addButtonText.textContent = text || window.variantStrings.addToCart;
      if(modifyClass && document.getElementById(`product-form-${this.dataset.section}`).closest('.product') && document.getElementById(`product-form-${this.dataset.section}`).closest('.product').querySelector('.out-of-stock')){
        document.getElementById(`product-form-${this.dataset.section}`).closest('.product').querySelector('.out-of-stock').style.display = "none";
        if(document.querySelector(".backinstock_feature_enable")){
          addButton.closest(".product-form-main-container-outer").querySelector(".matat-backin-stock-alert").classList.remove("active");
          addButton.classList.remove("hidden");
          addButton.closest(".product-form-main-container-outer").classList.remove("backinstock-active-main");
          addButton.closest("product-form").classList.remove("backinstock-active");
        }
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);


class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      const selectedRadio = Array.from(fieldset.querySelectorAll('input')).find(radio => radio.checked);
      if (selectedRadio) {
        const legendSpan = fieldset.querySelector("legend span");
        if (legendSpan) {
          // Get the price from the corresponding label's span
          const label = fieldset.querySelector(`label[for="${selectedRadio.id}"]`);
          let priceText = '';
          if (label) {
            const priceSpan = label.querySelector('.value-with-price');
            if (priceSpan) priceText = ' - ' + priceSpan.textContent.trim();
          }

          // Update legend with value + price
          legendSpan.innerHTML = selectedRadio.value + priceText;
        }
        return selectedRadio.value;
      }
    });
  }
  // updateOptions() {
  //   const fieldsets = Array.from(this.querySelectorAll('fieldset'));
  //   this.options = fieldsets.map((fieldset) => {
  //     var xx = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
  //     if(xx){
  //       if(xx.closest("fieldset") && xx.closest("fieldset").querySelector("legend span")){
  //           xx.closest("fieldset").querySelector("legend span").innerHTML = xx.value;
  //         }
  //       return xx.value;
  //     }else{
  //     }
  //   });
  // }
}

customElements.define('variant-radios', VariantRadios);

// Card product js 
function initCardVariants(scope = document) {
  scope.querySelectorAll('.card-wrapper').forEach(function (card) {
    if (card.dataset.variantInitialized) return; // prevent double init
    card.dataset.variantInitialized = 'true';

    const variantRadios = card.querySelector('variant-radios');
    if (!variantRadios) return;

    const variantData = JSON.parse(variantRadios.querySelector('[type="application/json"]').textContent);

    card.querySelectorAll('.card-product-options').forEach(function (label) {
      label.addEventListener('click', function () {

        const fieldset = label.closest('fieldset');
        fieldset.querySelectorAll('.card-product-options').forEach(l => l.classList.remove('active'));
        label.classList.add('active');

        const selectedOptions = [];
        variantRadios.querySelectorAll('fieldset').forEach(function (fs) {
          const activeLabel = fs.querySelector('.card-product-options.active');
          if (activeLabel) {
            selectedOptions.push(activeLabel.dataset.val);
          }
        });

        const matchedVariant = variantData.find(function (variant) {
          return selectedOptions.every(function (selectedOpt, i) {
            return variant.options[i] === selectedOpt;
          });
        });

        if (!matchedVariant) return;

        // Update hidden input
        const hiddenInput = card.querySelector('input[name="id"].product-variant-id');
        if (hiddenInput) hiddenInput.value = matchedVariant.id;

        // Update button
        const addBtn = card.querySelector('.quick-add__submit');
        const addBtnSpan = addBtn ? addBtn.querySelector('span:first-child') : null;
        if (addBtn && addBtnSpan) {
          if (matchedVariant.available) {
            addBtn.removeAttribute('disabled');
            addBtnSpan.textContent = window.variantStrings?.addToCart || 'Add to cart';
          } else {
            addBtn.setAttribute('disabled', 'disabled');
            addBtnSpan.textContent = window.variantStrings?.soldOut || 'Sold out';
          }
        }

        // Update price
        const priceRegularEl = card.querySelector('.price__regular .price-item--regular');
        const comparePriceEl = card.querySelector('.price__sale .price-item--regular');
        const salePriceEl = card.querySelector('.price__sale .price-item--sale');

        const formatMoney = (cents) => (cents / 100).toFixed(2) + ' ₪';

        if (matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price) {
          if (comparePriceEl) comparePriceEl.textContent = formatMoney(matchedVariant.compare_at_price);
          if (salePriceEl) salePriceEl.textContent = formatMoney(matchedVariant.price);
          card.querySelector('.price')?.classList.add('price--on-sale');
        } else {
          if (priceRegularEl) priceRegularEl.textContent = formatMoney(matchedVariant.price);
          card.querySelector('.price')?.classList.remove('price--on-sale');
        }
      });
    });
  });
}
// Run on page load
document.addEventListener('DOMContentLoaded', function () {
  initCardVariants();
});
// Card product js end

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
 
            var container = document.querySelector('#recomendation');
            var productItems = container.querySelectorAll('.grid__item');
            var isMobile = window.innerWidth <= 989;
            // Initialize main recommendation slider
            if (isMobile || productItems.length > 4) {
              new Flickity(container, {
                rightToLeft: true,
                cellAlign: 'right',
                pageDots: false,
                wrapAround: false,
                contain: true,
                prevNextButtons: true,
                responsive: [
                  {
                    breakpoint: 750,
                    settings: {
                      wrapAround: false,
                      contain: true,
                      prevNextButtons: true,
                      pageDots: false
                    }
                  }
                ]
              });
            }
            // Nested image sliders inside recommendation
            document.querySelectorAll("#recomendation .enable_image_slider .flickity_grid").forEach((elementItem) => {
              var innerItems = elementItem.querySelectorAll('.grid__item');
              if (isMobile || innerItems.length > 4) {
                new Flickity(elementItem, {
                  imagesLoaded: true,
                  rightToLeft: true,
                  cellAlign: 'right',
                  pageDots: false,
                  wrapAround: false,
                  draggable: false,
                  contain: true,
                  responsive: [
                    {
                      breakpoint: 750,
                      settings: {
                        freeScroll: true,
                        wrapAround: false,
                        contain: true,
                        prevNextButtons: true,
                        draggable: false,
                        pageDots: false
                      }
                    }
                  ]
                });
              }
            });
              const quickViewButtons = document.querySelectorAll(".mobile-quickview");
                if (quickViewButtons.length > 0) {
                    quickViewButtons.forEach((button) => {
                      button.addEventListener("click", (evt) => {
                        const cardWrapper = evt.target.closest(".card-wrapper");
                        if (!cardWrapper) return;
                        const quickAddButton = cardWrapper.querySelector(".quick-add__submit");
                        quickAddButton?.click();
                        
                        const variantRadios = cardWrapper.querySelector(".product-card_inline-variation input[name='size']");
                        const mobilePopupElement = document.querySelector(".product-vars-inner-main-popup");
                  
                        if (mobilePopupElement) {
                          const variationContainer = mobilePopupElement.querySelector(".variantion-item-radios");
                          if (variationContainer && variantRadios) {
                            mobilePopupElement.classList.add("active");
                            let sizeVariantsHTML = "";
                            cardWrapper.querySelectorAll(".product-card_inline-variation input[name='size']").forEach((input) => {
                              let $disableClass;
                              if(input.classList.contains("disabled")){
                                $disableClass = "disabled";
                              }
                              sizeVariantsHTML += `<button type="button" value="${input.getAttribute("id")}" class="mobile-popup-variant" ${$disableClass}>${input.value}</button>`;
                            });
                            variationContainer.innerHTML = sizeVariantsHTML;
                          }
                        }
                      });
                    });
                  }
          }

          // Call card product variant code
          if (typeof initCardVariants === 'function') initCardVariants();
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);




if(window.innerWidth < 750){
  if(!document.querySelector(".gift-card-single-main-product")){
    if(document.querySelector(".single_main_product_wrapper")){
      var flkty = new Flickity( '.product__media-list.contains-media', {
        "imagesLoaded": true,
        "rightToLeft":true,
        "cellAlign":"right",
        "pageDots": true,
        "prevNextButtons": false,
        "wrapAround": true
    });
    }
  }
  if(document.querySelector(".matat-mobile-zoom-btn")){
    document.querySelector(".matat-mobile-zoom-btn").addEventListener("click", (e)=>{
      document.querySelector(".product__media-wrapper .product__media-item.is-selected img").click()
    })
  }
}
if(document.querySelector(".matat-mobile-zoom-btn")){
    document.querySelector(".matat-mobile-zoom-btn").addEventListener("click", (e)=>{
      document.querySelector(".product__media-wrapper .product__media-item.is-selected img").click()
    })
  }
  
if(document.querySelector(".backinstock_feature_enable")){

  // backin stock feature for product page
if(document.querySelector(".single-main-product-page")){
  const stockPhone = document.getElementById('stock-phone');
  if(stockPhone){
  function validatePhoneNumber() {
    // Get and trim phone number input
    const phoneNumber = stockPhone.value.trim();

    // Regex pattern for 10-digit phone number
    const pattern = /^(?:(?:(\+?972|\(\+?972\)|\+?\(972\))?(?:\s|\.|-)?(5[0-9]{1}))|(0[23489]{1})|(0[57]{1}[0-9]))(?:\s|\.|-)?(\d{7}|([1-9]\d{8}))$/;

    // Validate phone number and update message
    const isValid = pattern.test(phoneNumber);
    return isValid;
  }
  stockPhone.addEventListener("keyup", (e)=>{
    let phone_value = e.target.value;
    if(phone_value != ""){
      validatePhoneNumber()
    }else{
      document.getElementById('phoneValidationMsg').textContent = "";
    }
  });
  document.querySelector(".matat-stock-notify-submit").addEventListener("click", ()=> {
  document.getElementById('phoneValidationMsg').textContent = '';  
  let check_phone = validatePhoneNumber();
  if (check_phone) {
              // Get data attributes from the button
              const button = document.querySelector(".matat-stock-notify-submit");
              const data = {
                  phone: document.getElementById("stock-phone").value, // Assuming there's an input for the phone number
                  dialCode: "972",
                  id: button.getAttribute("data-id"),
                  product_id: button.getAttribute("data-product_id"),
                  action: button.getAttribute("data-action"),
                  title: (button.getAttribute("data-title")),
                  price_varies: JSON.parse(button.getAttribute("data-price_varies")),
                  price: (button.getAttribute("data-price")),
                  price_max: (button.getAttribute("data-price_max")),
                  price_min: (button.getAttribute("data-price_min")),
                  has_only_default_variant: JSON.parse(button.getAttribute("data-has_only_default_variant")),
                  src: button.getAttribute("data-src"),
                  url: button.getAttribute("data-url"),
                  user_id: button.getAttribute("data-user_id"),
                  email: button.getAttribute("data-email"),
                  full_name: button.getAttribute("data-full_name"),
                  variant_id: button.getAttribute("data-variant-id"),
                  variant_title: button.getAttribute("data-variant-title")
              };

              fetch(`https://www.anipet.co.il/apps/text-me/restock-notifications`, {
                  method: 'POST', 
                  headers: {
                    "Content-Type": "application/json",
                    "x-shopify-shop-domain": Shopify.shop
                },
                body: JSON.stringify(data)
              })
              .then(response => {
                  if (!response.ok) {
                      throw new Error('Network response was not ok');
                  }

              })
              .then(data => {
                document.getElementById('phoneValidationMsg').style.color = "green"
                document.getElementById('phoneValidationMsg').textContent = 'אנו נחזור אליך ברגע שהמוצר יחזור למלאי';  
              })
              .catch(error => {
                  console.error('Error:', error);
              });
  } else {
      document.getElementById('phoneValidationMsg').textContent = "'מספר טלפון לא תקין.";
  }
  })
  document.querySelector('[name="id"]').addEventListener("change",(e)=>{
    let variant_change_val = e.target.value;
    document.querySelector(".matat-stock-notify-submit").setAttribute("data-variant-id",variant_change_val);
    document.querySelector(".matat-stock-notify-submit").setAttribute("data-id",variant_change_val);
  })
  }
}
// collection page back in stack
class BackinStockmatat extends HTMLElement{
  constructor() {
  super();
  this.addEventListener("click", () => {
    document.querySelector(".matat-product-card-stock").classList.toggle("active");
    document.body.classList.toggle("overflow-hidden");
    let $AllAttributes = this.attributes;
    this.copyAttributes($AllAttributes);
  })
}

copyAttributes(att){
  [...att].forEach((name) => {
    if(name.nodeName != "class"){
      document.querySelector("matat-stock-popup").setAttribute(name.nodeName,name.nodeValue);
    }
  })
}

}
customElements.define('matat-stock', BackinStockmatat);

// stock popup js starts from here
class matatStockPopup extends HTMLElement{
  constructor() {
    super();
    this.close = this.querySelector(".close-stock-popup");
    this.button = this.querySelector(".stock-popup-button");
    this.input = this.querySelector("#stock-phone-popup");
    this.close.addEventListener("click", () => {
      this.closest(".matat-product-card-stock").classList.remove("active");
      document.body.classList.remove("overflow-hidden");
    })
    this.button.addEventListener("click", (evt) => {
        this.submitStock(evt.target)
    })
    this.addEventListener("click", (evt) => {
      if(evt.target == this){
        this.closest(".matat-product-card-stock").classList.remove("active");
        document.body.classList.remove("overflow-hidden");
      }
    })
  }

  validatePhoneNumber(number) {
    // Get and trim phone number input
    const phoneNumber = number.trim();
    // Regex pattern for 10-digit phone number
    const pattern = /^(?:(?:(\+?972|\(\+?972\)|\+?\(972\))?(?:\s|\.|-)?(5[0-9]{1}))|(0[23489]{1})|(0[57]{1}[0-9]))(?:\s|\.|-)?(\d{7}|([1-9]\d{8}))$/;
    // Validate phone number and update message
    const isValid = pattern.test(phoneNumber);
    return isValid;
  }

  submitStock(ele){
  document.getElementById('popup_phoneValidation').textContent = '';   
  let check_phone = this.validatePhoneNumber(this.input.value);
  if (check_phone) {
              // Get data attributes from the button
              const datas = this;
              const data = {
                  phone: this.input.value, // Assuming there's an input for the phone number
                  dialCode: "972",
                  id: datas.getAttribute("data-id"),
                  product_id: datas.getAttribute("data-product_id"),
                  action: datas.getAttribute("data-action"),
                  title: (datas.getAttribute("data-title")),
                  price_varies: JSON.parse(datas.getAttribute("data-price_varies")),
                  price: (datas.getAttribute("data-price")),
                  price_max: (datas.getAttribute("data-price_max")),
                  price_min: (datas.getAttribute("data-price_min")),
                  has_only_default_variant: JSON.parse(datas.getAttribute("data-has_only_default_variant")),
                  src: datas.getAttribute("data-src"),
                  url: datas.getAttribute("data-url"),
                  user_id: datas.getAttribute("data-user_id"),
                  email: datas.getAttribute("data-email"),
                  full_name: datas.getAttribute("data-full_name"),
                  variant_id: datas.getAttribute("data-variant-id"),
                  variant_title: datas.getAttribute("data-variant-title")
              };

              fetch('https://www.anipet.co.il/apps/text-me/restock-notifications', {
                  method: 'POST', 
                  headers: {
                      'Content-Type': 'application/json',
                      "x-shopify-shop-domain": Shopify.shop
                  },
                  body: JSON.stringify(data)
              })
              .then(response => {
                  if (!response.ok) {
                      document.getElementById('popup_phoneValidation').textContent = "תגובת הרשת לא הייתה בסדר";
                      setTimeout(function(){
                        document.querySelector(".matat-product-card-stock").classList.remove("active");
                        document.body.classList.remove("overflow-hidden");
                      }, 500);  
                      throw new Error('Network response was not ok');
                  }

              })
              .then(data => {
                document.getElementById('popup_phoneValidation').classList.add("sucess");
                this.displaySuccessMessage("אנו נחזור אליך בהקדם האפשרי, תודה ששלחת");
                document.getElementById('popup_phoneValidation').textContent = 'אנו נחזור אליך ברגע שהמוצר יחזור למלאי';
                setTimeout(function(){
                  document.querySelector(".matat-product-card-stock").classList.remove("active");
                  document.body.classList.remove("overflow-hidden");
                }, 200);  
                
              })
              .catch(error => {
                  console.error('Error:', error);
              });
      } else {
        document.getElementById('popup_phoneValidation').classList.remove("sucess");
          document.getElementById('popup_phoneValidation').textContent = "מספר טלפון לא תקין.";
      }
  }
  displaySuccessMessage(message) {
    this.displayAlertMessage(message, "success");
  }
  displayAlertMessage(message, type = "error") {
    const alertBox = document.createElement("div");
    alertBox.classList.add("alert-box", type);
    alertBox.textContent = message;

    document.body.appendChild(alertBox);

    setTimeout(() => {
        alertBox.remove();
    }, 5000); // Remove after 5 seconds
  } 
}
customElements.define('matat-stock-popup', matatStockPopup);

}


// login drawer focused css
// const loginPhoneInput = document.querySelector(".matat-login-main #login_phone");
// const otp_codeInput = document.querySelector(".matat-login-main #login_otp");
// const login_page_phoneInput = document.querySelector(".customer.login .matat-login-main #login_phone");
// const login_page_otp_codeInput = document.querySelector(".customer.login .matat-login-main #login_otp");
const toggleFocusClass = (e) => {
  if(e.target.closest(".floating_input_wrap")){
    e.target.closest(".floating_input_wrap").classList.toggle("focused", e.type === "focus");
  }
  if(e.type == "blur" && e.target.value != ""){
    if(e.target.closest(".floating_input_wrap")){
      e.target.closest(".floating_input_wrap").classList.add("populated");
    }
  }else{
    if(e.target.closest(".floating_input_wrap")){
      e.target.closest(".floating_input_wrap").classList.remove("populated");
    }
    
  }
};
document.querySelectorAll(".form-control").forEach((evt) => {
  evt.addEventListener("focus", toggleFocusClass);
  evt.addEventListener("blur", toggleFocusClass);
})
// loginPhoneInput.addEventListener("focus", toggleFocusClass);
// loginPhoneInput.addEventListener("blur", toggleFocusClass);
// otp_codeInput.addEventListener("focus", toggleFocusClass);
// otp_codeInput.addEventListener("blur", toggleFocusClass);
// if(login_page_phoneInput){
//   login_page_phoneInput.addEventListener("focus", toggleFocusClass);
//   login_page_phoneInput.addEventListener("blur", toggleFocusClass);
// }
// if(login_page_otp_codeInput){
//   login_page_otp_codeInput.addEventListener("focus", toggleFocusClass);
//   login_page_otp_codeInput.addEventListener("blur", toggleFocusClass);
// }
class GoogleLoginBtn extends HTMLElement{
  constructor() {
    super();
    this.querySelector(".google-button").addEventListener('click', () => {
      document.querySelector("#google-login").click();
    })
  }

}
customElements.define('button-google', GoogleLoginBtn);
document.addEventListener("click", (e) =>{
  if(e.target.classList.contains("modal-overlay") && e.target.closest("details").hasAttribute("open")){
      e.target.closest("details").removeAttribute("open");
      document.querySelector(".section-header").classList.remove("menu-open");
  }
  if(e.target.classList.contains("extra_color_button")){
    e.target.style.display = "none";
    e.target.closest(".card-variation-color").querySelectorAll(".color-hide-plus").forEach((ele) => {
      ele.classList.remove("color-hide-plus")
    })
  }
  if(e.target.classList.contains("mobile-popup-variant")){
    e.target.closest(".product-vars-inner-main-popup").classList.remove("active");
    let $elementVariant = document.querySelector(`#${e.target.value}`);
    var evt = document.createEvent("HTMLEvents");
        evt.initEvent("change", false, true);
        $elementVariant.click();
        $elementVariant.dispatchEvent(evt);
  }
  if(e.target.classList.contains("product-vars-inner-main-popup")){
    e.target.classList.remove("active");
  }
  if(e.target.classList.contains("variant_popup_close_mobile") || e.target.closest(".variant_popup_close_mobile")){
    e.target.closest(".product-vars-inner-main-popup").classList.remove("active");
  }
  // mobile quick view js starts from here
  if(e.target.classList.contains("mobile-quickview") || e.target.closest(".mobile-quickview")){
      // const quickViewButtons = document.querySelectorAll(".mobile-quickview");
      // if (quickViewButtons.length > 0) {
        // quickViewButtons.forEach((button) => {
          // button.addEventListener("click", (evt) => {
          // });
        // });
      // }
      const cardWrapper = e.target.closest(".card-wrapper");
        if (!cardWrapper) return;
        const quickAddButton = cardWrapper.querySelector(".quick-add__submit");
        quickAddButton?.click();
        
        const variantRadios = cardWrapper.querySelector(".product-card_inline-variation input[name='size']");
        const mobilePopupElement = document.querySelector(".product-vars-inner-main-popup");
        if(variantRadios){
          if (mobilePopupElement) {
            const variationContainer = mobilePopupElement.querySelector(".variantion-item-radios");
            if (variationContainer && variantRadios) {
              mobilePopupElement.classList.add("active");
              let sizeVariantsHTML = "";
              cardWrapper.querySelectorAll(".product-card_inline-variation input[name='size']").forEach((input) => {
                let $disableClass;
                if(input.classList.contains("disabled")){
                  $disableClass = "disabled";
                }
                sizeVariantsHTML += `<button type="button" value="${input.getAttribute("id")}" class="mobile-popup-variant" ${$disableClass}>${input.value}</button>`;
              });
              variationContainer.innerHTML = sizeVariantsHTML;
            }
          }
        }else{
          cardWrapper.querySelector(".card__inner .product_quick_add_wrap .default_variant_card input[type='radio']").click();
        }
        
    }
  // ends here
})
document.addEventListener("DOMContentLoaded", (event) => {
  // document.querySelector(".header-icon-search-mobile").addEventListener("click", ()=>{
  //   if(document.querySelector(".header__search details").hasAttribute("open")){
  //     document.querySelector(".section-header").classList.remove("menu-open");
  //   }else{
  //     document.querySelector(".section-header").classList.add("menu-open");
  //   }
  //   if(document.querySelector("#Details-menu-drawer-container").hasAttribute("open")){
  //     document.querySelector("#Details-menu-drawer-container").removeAttribute("open");
  //     document.querySelector("#Details-menu-drawer-container").classList.remove("menu-opening");
  //     document.querySelector(".header__icon--menu").setAttribute("aria-expanded",false);
  //     document.body.classList.remove("overflow-hidden-tablet")
  //   }
  //  })  
   if(document.body.classList.contains("product-template")){
    function scrollToTop() {
      window.scrollTo(0, 0);
    }
      scrollToTop()
   }
});


// ========navigation scroll

if(document.querySelector(".announcement-bar-section")){
  let annoucement_bar = document.querySelector(".announcement-bar-section").offsetHeight;
  let header_height = document.querySelector(".shopify-section-group-header-group.section-header").offsetHeight;
  let Total_height = annoucement_bar + header_height;
  let height_REM = Total_height / 10;
  document.querySelector("nav.menu-drawer__navigation").style.height = `calc(100dvh - ${height_REM}rem)`;
}else{

  let header_height = document.querySelector(".shopify-section-group-header-group.section-header").offsetHeight;
  let height_REM = header_height / 10;
  document.querySelector("nav.menu-drawer__navigation").style.height = `calc(100dvh - ${height_REM}rem)`;
}


document.addEventListener("DOMContentLoaded", (event) => {
  document.querySelector('.header-icon-search-mobile').addEventListener('click', function(){
      if(document.querySelector("details.menu-drawer-container").hasAttribute("open")){
          document.querySelector("details.menu-drawer-container").removeAttribute("open")
          document.querySelector("details.menu-drawer-container summary").removeAttribute("aria-expanded")
      }
  })
})

// Search model function
document.addEventListener("DOMContentLoaded", function () {
  const modal = document.querySelector(".search-modal");
  const toggle = document.querySelector(".modal__toggle");

  if (!modal || !toggle) return;

  // If toggle is a <summary> inside a <details>, prevent the native toggle
  const maybeSummary = toggle.tagName === "SUMMARY" ? toggle : null;
  const details = maybeSummary ? maybeSummary.closest("details") : null;

  const searchInput = toggle.querySelector('input[type="search"]');

  // Clicking the search bar should not open the modal, only focus the input
  toggle.addEventListener("click", (e) => {
    // Prevent <summary> from toggling its details automatically
    if (maybeSummary) e.preventDefault();

    e.stopPropagation();
  });

  const openModal = () => {
    modal.classList.add("is-open");
    if (details) details.setAttribute("open", "");
  };

  const closeModal = () => {
    modal.classList.remove("is-open");
    if (details) details.removeAttribute("open");
  };

  // Open the modal live while typing, close it when the input is emptied
  if (searchInput) {
    searchInput.addEventListener("input", () => {
      if (searchInput.value.trim().length > 0) {
        openModal();
      } else {
        closeModal();
      }
    });

    // The reset (clear) button empties the input, so close the modal too
    if (searchInput.form) {
      searchInput.form.addEventListener("reset", closeModal);
    }
  }

  // Stop clicks inside the modal from bubbling to document
  // Use pointerdown to match the document listener
  modal.addEventListener("pointerdown", (e) => {
    e.stopPropagation();
  });

  // Close when clicking/tapping anywhere outside (pointerdown catches more cases)
  document.addEventListener("pointerdown", (e) => {
    if (!modal.classList.contains("is-open")) return;

    // Get composedPath for shadow DOM compatibility
    const path = (e.composedPath && e.composedPath()) || (e.path || []);
    // Fallback checks
    const clickedInside =
      (path && path.includes(modal)) ||
      modal.contains(e.target) ||
      false;
    const clickedToggle =
      (path && path.includes(toggle)) ||
      toggle.contains(e.target) ||
      false;

    if (!clickedInside && !clickedToggle) {
      modal.classList.remove("is-open");
      if (details) details.removeAttribute("open");
    }
  });

  const closeBtn = document.querySelector(".search-modal__close-button");
  if (closeBtn) {
    closeBtn.addEventListener("click", (e) => {
      e.preventDefault();
      modal.classList.remove("is-open");
      if (details) details.removeAttribute("open");
    });
  }

  // Close on Escape key
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && modal.classList.contains("is-open")) {
      modal.classList.remove("is-open");
      if (details) details.removeAttribute("open");
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // Run after all apps & sliders modify the DOM
  setTimeout(function () {
    document.querySelectorAll('[aria-hidden="true"]').forEach(function(el) {
 
      // Skip if element is focusable or interactive
      if (
        el.tagName === 'A' ||
        el.tagName === 'BUTTON' ||
        el.hasAttribute('href') ||
        el.hasAttribute('tabindex')
      ) {
        return; // leave aria-hidden for safety
      }
 
      // Remove aria-hidden for all other elements globally
      el.removeAttribute("aria-hidden");
    });
  }, 400);
});

document.addEventListener("DOMContentLoaded", function () {
  function updateSlides() {
    document.querySelectorAll('.slideshow__slide').forEach(slide => {
      const link = slide.querySelector('.full_banner_clickable');
      if (!link) return;

      if (slide.classList.contains('is-selected')) {
        link.removeAttribute('tabindex');
        link.removeAttribute('aria-hidden');
      } else {
        link.setAttribute('tabindex', '-1');
        link.setAttribute('aria-hidden', 'true');
      }
    });
  }

  setInterval(updateSlides, 300);
});

document.addEventListener("DOMContentLoaded", function () {
  function fixFlickityAccessibility() {
    document.querySelectorAll('.flickity-slider > *').forEach(slide => {
      const isHidden = slide.getAttribute('aria-hidden') === 'true';

      slide.querySelectorAll('a, button, input, select, textarea').forEach(el => {
        if (isHidden) {
          el.setAttribute('tabindex', '-1');
        } else {
          el.removeAttribute('tabindex');
        }
      });
    });
  }

  // Run initially
  fixFlickityAccessibility();

  // Re-run after Flickity changes slide
  document.querySelectorAll('.flickity-enabled').forEach(slider => {
    slider.addEventListener('settle.flickity', fixFlickityAccessibility);
    slider.addEventListener('change.flickity', fixFlickityAccessibility);
  });
});

document.addEventListener("DOMContentLoaded", function () {

  function fixChoicesAccessibility(root = document) {

    // ✅ Fix listbox accessibility name
    root.querySelectorAll('.choices[role="listbox"]').forEach(el => {
      if (!el.hasAttribute('aria-label') && !el.hasAttribute('aria-labelledby')) {
        el.setAttribute('aria-label', 'Select option'); // customize if needed
      }
    });

    // ✅ Fix options (aria-selected needs role="option")
    root.querySelectorAll('.choices__item[aria-selected]').forEach(el => {
      if (!el.hasAttribute('role')) {
        el.setAttribute('role', 'option');
      }
    });

    // ✅ Clean invalid aria attributes
    root.querySelectorAll('.choices[role="listbox"]').forEach(el => {
      el.removeAttribute('aria-haspopup');
      el.removeAttribute('aria-expanded');
    });

    root.querySelectorAll('.choices__list--dropdown').forEach(el => {
      el.removeAttribute('aria-expanded');
    });
  }

  // ✅ Run initially
  fixChoicesAccessibility();

  // ✅ Watch for dynamic updates (IMPORTANT)
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length) {
        fixChoicesAccessibility(mutation.target);
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});
/*
  Product bundles (main product "bundles" block).
  Renders a card per volume tier held in the bundle app metafield of the
  selected variant, and adds that tier's quantity straight to the cart drawer.
*/
if (!customElements.get('product-bundles')) {
  customElements.define(
    'product-bundles',
    class ProductBundles extends HTMLElement {
      constructor() {
        super();

        this.list = this.querySelector('[data-bundle-list]');
        this.errorElement = this.querySelector('[data-bundle-error]');
        this.sectionId = this.dataset.section;
        this.moneyFormat = this.dataset.moneyFormat || '{{amount}}';
        this.showSingle = this.dataset.showSingle !== 'false';
        this.singleTitle = this.dataset.singleTitle || '';
        this.singleImage = this.dataset.singleImage || '';
        this.singleImageAlt = this.dataset.singleImageAlt || '';
        this.unitsLabel = this.dataset.unitsLabel || '';
        this.variants = this.parseVariants();
        this.currentVariantId = Number(this.dataset.variantId) || null;
      }

      connectedCallback() {
        this.onClickHandler = this.onClick.bind(this);
        this.onVariantInputHandler = this.onVariantInput.bind(this);

        this.addEventListener('click', this.onClickHandler);
        document.addEventListener('change', this.onVariantInputHandler);
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const variant = event && event.data ? event.data.variant : null;
          if (variant) this.setVariant(variant.id);
        });

        this.renderTiers();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClickHandler);
        document.removeEventListener('change', this.onVariantInputHandler);
        if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
      }

      get cart() {
        return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      }

      get currentVariant() {
        return this.variants.find((variant) => variant.id === this.currentVariantId) || null;
      }

      parseVariants() {
        const dataElement = this.querySelector('[data-bundle-config]');
        if (!dataElement) return [];

        let data;
        try {
          data = JSON.parse(dataElement.textContent);
        } catch (error) {
          console.error('Bundles: could not read the bundle configuration', error);
          return [];
        }

        const productConfig = this.normalizeConfig(data.productConfig);
        const variants = (data.variants || []).map((variant) => ({
          id: Number(variant.id),
          price: Number(variant.price),
          available: variant.available === true,
          config: this.normalizeConfig(variant.config) || productConfig,
        }));

        // A configuration can point at another variant through componentVariantId,
        // so let the offer follow the variant it was set up for.
        variants.forEach((variant) => {
          const componentId = this.componentVariantId(variant.config);
          if (!componentId || componentId === variant.id) return;
          const component = variants.find((candidate) => candidate.id === componentId);
          if (component && !component.config) component.config = variant.config;
        });

        return variants;
      }

      normalizeConfig(rawConfig) {
        let config = rawConfig;

        // The metafield is json, but a text metafield holding json parses to a string.
        if (typeof config === 'string') {
          try {
            config = JSON.parse(config);
          } catch (error) {
            return null;
          }
        }

        if (!config || typeof config !== 'object') return null;
        if (config.active === false) return null;
        if (config.kind && String(config.kind).toUpperCase() !== 'VOLUME') return null;

        const tiers = (Array.isArray(config.tiers) ? config.tiers : [])
          .map((tier) => ({
            units: Math.floor(Number(tier.units)),
            title: tier.title,
            type: tier.type,
            value: Number(tier.value) || 0,
            imageUrl: tier.imageUrl || '',
            imageAlt: tier.imageAlt || '',
          }))
          .filter((tier) => tier.units > 0)
          .sort((first, second) => first.units - second.units);

        if (!tiers.length) return null;

        return { kind: config.kind, componentVariantId: config.componentVariantId, tiers: tiers };
      }

      componentVariantId(config) {
        if (!config || !config.componentVariantId) return null;
        const id = String(config.componentVariantId).match(/(\d+)$/);
        return id ? Number(id[1]) : null;
      }

      setVariant(variantId) {
        const id = Number(variantId);
        if (!id || id === this.currentVariantId) return;
        if (!this.variants.some((variant) => variant.id === id)) return;

        this.currentVariantId = id;
        this.renderTiers();
      }

      onVariantInput(event) {
        if (!event.target.closest || !event.target.closest('variant-radios, variant-selects')) return;

        // The theme writes the new id into the hidden form input before it
        // re-renders the section, so read it back on the next tick.
        setTimeout(() => {
          const form = document.getElementById(`product-form-${this.sectionId}`);
          const input = form ? form.querySelector('[name="id"]') : null;
          if (input && input.value) this.setVariant(input.value);
        });
      }

      renderTiers() {
        const variant = this.currentVariant;
        const config = variant ? variant.config : null;

        this.list.innerHTML = '';
        this.showError();

        if (!variant || !config) {
          this.hidden = true;
          return;
        }

        const offers = config.tiers.slice();
        if (this.showSingle && !offers.some((tier) => tier.units === 1)) {
          offers.unshift({
            units: 1,
            title: this.singleTitle,
            type: null,
            value: 0,
            imageUrl: this.singleImage,
            imageAlt: this.singleImageAlt,
          });
        }

        offers.forEach((offer) => this.list.appendChild(this.buildCard(offer, variant)));
        this.hidden = false;
      }

      buildCard(offer, variant) {
        const fullPrice = variant.price * offer.units;
        const bundlePrice = this.bundlePrice(fullPrice, offer);
        const saving = Math.max(0, fullPrice - bundlePrice);

        const card = document.createElement('div');
        card.className = 'bundle-card';
        card.dataset.units = offer.units;
        if (saving > 0) card.classList.add('bundle-card--discounted');

        // The tier image, when the app has one, reads before the title.
        const heading = document.createElement('div');
        heading.className = 'bundle-card__heading';

        if (offer.imageUrl) {
          const image = document.createElement('img');
          image.className = 'bundle-card__image';
          image.src = offer.imageUrl;
          image.alt = offer.imageAlt || offer.title || '';
          image.width = 76;
          image.height = 76;
          image.loading = 'lazy';
          heading.appendChild(image);
        }

        const title = document.createElement('span');
        title.className = 'bundle-card__title';
        title.textContent = offer.title || `${offer.units} ${this.unitsLabel}`.trim();
        heading.appendChild(title);
        card.appendChild(heading);

        const priceWrapper = document.createElement('div');
        priceWrapper.className = 'bundle-card__price';

        const priceLine = document.createElement('div');
        priceLine.className = 'bundle-card__price-line';

        // The struck price reads first, the price paid second (right to left in Hebrew).
        if (saving > 0) {
          const compareAtPrice = document.createElement('s');
          compareAtPrice.className = 'bundle-card__price-compare';
          compareAtPrice.innerHTML = this.formatMoney(fullPrice);
          priceLine.appendChild(compareAtPrice);
        }

        const price = document.createElement('span');
        price.className = 'bundle-card__price-final';
        price.innerHTML = this.formatMoney(bundlePrice);
        priceLine.appendChild(price);

        priceWrapper.appendChild(priceLine);

        if (saving > 0) {
          const savingElement = document.createElement('span');
          savingElement.className = 'bundle-card__saving';
          savingElement.textContent = `(-${this.formatNumber(
            this.savingPercent(fullPrice, saving, offer)
          )}%)`;
          priceWrapper.appendChild(savingElement);
        }

        card.appendChild(priceWrapper);
        card.appendChild(this.buildButton(offer, variant));

        return card;
      }

      buildButton(offer, variant) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'button bundle-card__button';
        button.dataset.bundleAdd = '';
        button.dataset.units = offer.units;
        if (this.cart) button.setAttribute('aria-haspopup', 'dialog');

        const label = document.createElement('span');
        label.textContent = variant.available
          ? window.variantStrings.addToCart
          : window.variantStrings.soldOut;
        button.appendChild(label);

        const spinner = document.createElement('div');
        spinner.className = 'loading-overlay__spinner hidden';
        spinner.innerHTML =
          '<svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg>';
        button.appendChild(spinner);

        if (!variant.available) button.setAttribute('disabled', 'disabled');

        return button;
      }

      bundlePrice(fullPrice, offer) {
        if (!offer.type || offer.value <= 0) return fullPrice;

        if (offer.type === 'percentage') {
          return Math.max(0, Math.round(fullPrice - (fullPrice * offer.value) / 100));
        }

        // A "fixed" tier holds the price of the whole bundle.
        return Math.max(0, Math.round(offer.value * 100));
      }

      // A fixed tier carries no percentage, so measure what it saves against the
      // regular price of the same units.
      savingPercent(fullPrice, saving, offer) {
        if (offer.type === 'percentage') return offer.value;
        if (!fullPrice) return 0;
        return Math.round((saving / fullPrice) * 1000) / 10;
      }

      onClick(event) {
        const button = event.target.closest('[data-bundle-add]');
        if (!button || button.hasAttribute('disabled')) return;

        event.preventDefault();
        this.addToCart(button);
      }

      addToCart(button) {
        const variant = this.currentVariant;
        if (!variant) return;

        const cart = this.cart;

        // No line item properties on purpose: lines of the same variant then
        // merge into one cart line, and the bundle app's cart transform prices
        // the combined quantity as a single bundle (it sets the tier title and
        // the bundle price on that line).
        const body = {
          items: [{ id: variant.id, quantity: Number(button.dataset.units) || 1 }],
        };

        if (cart) {
          body.sections = cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
          cart.setActiveElement(button);
        }

        this.showError();
        this.setLoading(button, true);

        fetch(`${routes.cart_add_url}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-bundles',
                productVariantId: variant.id,
                errors: response.description,
                message: response.message,
              });
              this.showError(response.description || response.message);
              return;
            }

            if (!cart) {
              window.location = routes.cart_url;
              return;
            }

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-bundles',
              productVariantId: variant.id,
            });
            cart.classList.remove('is-empty');
            cart.renderContents(response);
          })
          .catch((error) => {
            console.error(error);
            this.showError(window.cartStrings ? window.cartStrings.error : '');
          })
          .finally(() => this.setLoading(button, false));
      }

      setLoading(button, loading) {
        const spinner = button.querySelector('.loading-overlay__spinner');
        button.classList.toggle('loading', loading);
        if (spinner) spinner.classList.toggle('hidden', !loading);
        if (loading) {
          button.setAttribute('aria-disabled', 'true');
        } else {
          button.removeAttribute('aria-disabled');
        }
      }

      showError(message) {
        if (!this.errorElement) return;
        this.errorElement.textContent = message || '';
        this.errorElement.toggleAttribute('hidden', !message);
      }

      formatNumber(value) {
        return Number(value.toFixed(2)).toString();
      }

      formatMoney(cents) {
        const placeholder = /\{\{\s*(\w+)\s*\}\}/;
        const match = this.moneyFormat.match(placeholder);
        if (!match) return this.moneyFormat;

        const withDelimiters = (precision, thousands, decimal) => {
          const amount = (cents / 100).toFixed(precision);
          const parts = amount.split('.');
          const units = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
          // Whole amounts read better without the ".00" tail.
          if (!parts[1] || Number(parts[1]) === 0) return units;
          return units + decimal + parts[1];
        };

        let value;
        switch (match[1]) {
          case 'amount_no_decimals':
            value = withDelimiters(0, ',', '.');
            break;
          case 'amount_with_comma_separator':
            value = withDelimiters(2, '.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            value = withDelimiters(0, '.', ',');
            break;
          case 'amount_with_space_separator':
            value = withDelimiters(2, ' ', ',');
            break;
          case 'amount_no_decimals_with_space_separator':
            value = withDelimiters(0, ' ', ',');
            break;
          case 'amount_with_apostrophe_separator':
            value = withDelimiters(2, String.fromCharCode(39), '.');
            break;
          default:
            value = withDelimiters(2, ',', '.');
        }

        return this.moneyFormat.replace(placeholder, value);
      }
    }
  );
}
